import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'job-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})

export class ListItemComponent implements OnInit {

  @Input() job;
  @Input() user;
  @Input() users;

  constructor() { }

  ngOnInit(): void {
  }

}
